import React, { useRef } from 'react'
import SecondHeader from '../../../components/SecondHeader/SecondHeader'
import CorporateSIdebar from '../../../components/corporateSidebar/CorporateSIdebar'
import DashboardSidebarHeader from '../../../components/corporateSidebar/DashboardSidebarHeader'
import useDashboardSidebarToggle from '../../../hooks/useDashboardSidebarToggle'

const DashboardLayout = ({ children }) => {
    const sidebarRef = useRef(null);
    const { sidebarOpen, closeSidebar } = useDashboardSidebarToggle(sidebarRef);

    return (
        <>
            <SecondHeader hideMobileNav />
            {sidebarOpen && <div className="dashboard-sidebar-backdrop" onClick={closeSidebar}></div>}
            <div className="container mt-3">
                <div className="row dashboard-shell-row">
                    <div
                        ref={sidebarRef}
                        className={`col-xl-3 col-lg-3 col-md-4 dashboard-sidebar-col${sidebarOpen ? ' dashboard-sidebar-open' : ''}`}
                    >
                        <DashboardSidebarHeader />
                        <CorporateSIdebar />
                    </div>

                    <div className="col-xl-9 col-lg-9 col-md-8">
                        {children}
                    </div>
                </div>
            </div>
        </>
    )
}

export default DashboardLayout